import { FRChartTimeFrames } from 'features/company/constants.types';
import { CoreChartOptions } from 'chart.js';
import { ChartContainer, MainChartContent } from 'features/company/Chart/styled';
import Link from 'next/link';
import EmptyChart from 'features/company/Chart/EmptyChart';
import CompanyChart from './CompanyChart';
import { CompanyChartType, FRChartType } from '../types';

type MainChartProps = {
  visible: boolean;
  symbol: string;
  chart: CompanyChartType;
  timeframe: FRChartTimeFrames;
  chartType: FRChartType;
  disableChartbitLink: boolean;
  isLoadingChart: boolean;
  onClickChart?: CoreChartOptions<'line'>['onClick'];
}

const MainChart = ({
  visible,
  symbol,
  chart,
  timeframe,
  chartType,
  disableChartbitLink,
  isLoadingChart,
  onClickChart,
}: MainChartProps) => {
  if (!visible) return null;

  return (
    <MainChartContent>
      {chart && (
        <ChartContainer>
          {disableChartbitLink ? (
            <CompanyChart
              chart={chart}
              chartType={chartType}
              timeframe={timeframe}
              onClickChart={onClickChart}
            />
            ) : (
              <Link href={`/symbol/${symbol}/chartbit`} passHref>
                <a>
                  <CompanyChart
                    chart={chart}
                    chartType={chartType}
                    timeframe={timeframe}
                    onClickChart={onClickChart}
                  />
                </a>
              </Link>
            )}
        </ChartContainer>
      )}
      {!isLoadingChart && !chart && <EmptyChart />}
    </MainChartContent>
  );
};

export default MainChart;
